import getConfig from './utils/getConfig';
import validateConfigData from './utils/validateConfigData';

//https://www.roimotors.com/new-inventory/index.htm?_integrationMode=debug
//www.roimotors.com/used-inventory/index.htm?_integrationMode=debug&start=17
//https://www.roimotors.com/used/Dodge/2019-Dodge-Grand+Caravan-11070aed0a0e087f0c102a7803abbd86.htm?_integrationMode=debug
//https://www.roimotors.com/financing/application.htm?_integrationMode=debug

//https://666be2879758257182d187fc--dealer-com.netlify.app/dealerform.3aeedc8a936f0933be4d.js

// https://demo.roimotors.com/tools/your-landing-page.htm?_integrationMode=debug

// (async APILoader => {
//   const API = await APILoader.create();
//   API.test('http://localhost:3002/dealerPreQualForm.js');
// })(window.DDC.APILoader);

// OF-1757
// Shared GUID-to-template logic
const guidMap = new Map([
  ["3f2504e0-4f89-41d3-9a0c-0305e82c3301", 2],
  ["6ba7b810-9dad-11d1-80b4-00c04fd430c8", 3],
  ["9bdbb4a0-5c42-4b79-bd53-8903fa0e7d53", 4],
  ["a17fc4d0-48c3-4c6f-bf80-6f3d7f52e2b8", 5],
  ["b4c38d0a-69f3-49d6-9b61-0ad1a8fcfd74", 6],
  ["cfc693e0-7d3b-4b34-9c32-f9902a68d8b4", 7],
  ["e2c02d7a-39b8-4203-b9c4-09e38f3b4e6a", 8],
  ["f8b6cc02-5a1d-40d1-a1c6-285b679e6c9a", 9],
  ["0263e013-1a2c-4d68-b995-b68d9b1e19b2", 10],
  ["13e7cf10-6bf1-4905-8a74-8c16b4edb0ae", 11],
  ["2f5a0f9d-bb41-4a8a-bf3b-3a234a1161e4", 12],
  ["38d456f8-5b28-4d7a-98a1-048b2c9470dc", 13],
  ["4eac8c5a-3b73-4f8f-812d-69d37e6dc34f", 14],
  ["5c9a4b37-b0cf-46f9-91e4-3a1fa46e3a1d", 15],
  ["6717bfb9-23fc-49aa-a9ec-0cc1f4ffb981", 16],
  ["72eb8bc3-1db8-42a3-98b6-3e5d4f68d6a4", 17],
  ["889a26b4-86d1-46c6-b8b8-d50eb4377b7e", 18],
  ["9f3f89df-7e56-42a9-92e1-8ea5f9f3cde9", 19],
  ["a64b0e60-2907-4b56-94c3-d72d058c5e10", 20]
]);

function getTemplateNumber(guid) {
  return guidMap.get(guid) || '';
}

function getUpdatedUrl(template, url) {
  const templateNumber = getTemplateNumber(template);
  if (templateNumber && templateNumber !== 1) {
    return url.replace(/(index)(\.html)$/, `index${templateNumber}$2`);
  }
  return url;
}

function setModalAttributes(modalDiv, config) {
  const attributes = [
    'classlist', 'url', 'buyercallinputs', 'customerdetails', 'title', 'subtitle',
    'button-img-url', 'colorprimary', 'colorsecondary', 'infosectionbackground',
    'formLogo', 'submitButtonText', 'inventoryLinkText', 'vehicleData', 'mainmessage',
    'lowestonly', 'additionalParams', 'pic', 'dcv', 'rpl', 'formid', 'template',
    'disclaimer', 'vin', 'odometer', 'cdsid', 'purchase', 'msrp', 'downpayment',
    'NoPaymentSuccessMessage', 'apiparam', 'gtmid', 'buttonprimary', 'buttonsecondary'
  ];

  for (const attr of attributes) {
    const val = config[attr];
    if (attr === 'classlist') {
      if (val) {
        val.split(' ').forEach(cls => {
          if (cls) modalDiv.classList.add(cls);
        });
      }
    } else {
      if (val === undefined || val === null) {
        modalDiv.setAttribute(attr, '');
      } else if (typeof val === 'object') {
        modalDiv.setAttribute(attr, JSON.stringify(val));
      } else {
        modalDiv.setAttribute(attr, val);
      }
    }
  }
}

(async (APILoader) => {
  const API = await APILoader.create();
  const config = await getConfig();
  const siteConfigData = validateConfigData(config);
  if (!siteConfigData) return;

  // Hide the widget's default launch button via CSS
  const hideDefaultCss = document.createElement('style');
  hideDefaultCss.innerHTML = `
    .cta__buyerCall__modalLaunch_buttonLaunch { display: none !important; }
  `;
  document.head.appendChild(hideDefaultCss);

  API.loadJS(siteConfigData.widgetformUrl).then(() => {
    API.subscribe('page-load-v1', (ev) => {
      const { searchPage, detailPage, pageName, siteId } = ev.payload;
      const siteConfig = siteConfigData.sites[siteId];
      if (!siteConfig) {
        console.log('Dealercom siteID not present in config', siteId);
        return;
      }

      siteConfig.url = getUpdatedUrl(siteConfig.template, siteConfig.url);

      // Primary CTA callback
      const callback = (elem, meta) => {
        const containerDiv = document.createElement('div');
        containerDiv.className = 'cta__buyerCall__widgetcontainer';

        const modalLaunchDiv = document.createElement('div');
        modalLaunchDiv.className = 'cta__buyerCall__modalLaunch';
        modalLaunchDiv.setAttribute('ismodal', 'true');
        setModalAttributes(modalLaunchDiv, siteConfig);

        const styledButton = document.createElement('button');
        styledButton.textContent = siteConfig.title || 'Open Modal';
        styledButton.className = 'btn btn-primary btn-block';
        styledButton.addEventListener('click', () => {
          const widgetBtn = containerDiv.querySelector('.cta__buyerCall__modalLaunch_buttonLaunch');
          widgetBtn?.click();
        });

        containerDiv.append(styledButton, modalLaunchDiv);
        API.append(elem, containerDiv);
      };

      // Landing page/form callback (inline form, no button)
      const callbackForm = (elem, meta) => {
        const containerDiv = document.createElement('div');
        containerDiv.className =
          'cta__buyerCall__widgetcontainer container-max-md page-section px-4 py-8 px-md-5 px-lg-6 px-xl-8';

        const modalLaunchDiv = document.createElement('div');
        modalLaunchDiv.className = 'cta__buyerCall__modalLaunch';
        modalLaunchDiv.setAttribute('ismodal', 'false');
        setModalAttributes(modalLaunchDiv, siteConfig);

        containerDiv.appendChild(modalLaunchDiv);
        API.append(elem, containerDiv);
      };

      if (searchPage || detailPage) {
        API.insert('vehicle-ctas', callback);
      } else if (pageName === 'OFFERLOGIX_PREQUALIFY') {
        API.insert('content', callbackForm);
      }
    });
  });
})(window.DDC.APILoader);
